import { logEvent } from 'firebase/analytics';
import posthog from 'posthog-js';
import { analyticsPromise } from '../firebase';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false, // we track page_view manually via PageTracker
    persistence: 'localStorage',
    session_recording: {
      maskAllInputs: true,
    },
  });
}

export async function track(event: string, params?: Record<string, unknown>) {
  const analytics = await analyticsPromise;
  if (analytics) logEvent(analytics, event, params);
  if (POSTHOG_KEY) posthog.capture(event, params);
}

export function identifyUser(uid: string, props?: Record<string, unknown>) {
  if (POSTHOG_KEY) posthog.identify(uid, props);
}
